// Importa a configuração do Axios antes de qualquer outro módulo que possa usar Axios
import "./services/axios-config";

import AppProvider from "providers/AppProvider";
import BreakpointsProvider from "providers/BreakpointsProvider";
import SettingsPanelProvider from "providers/SettingsPanelProvider";
import {ToastProvider} from "providers/ToastProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import {QueryClientProvider, QueryClient} from "@tanstack/react-query";
import {RouterProvider} from "react-router-dom";
import {router} from "Routes";
import {PermissionModalProvider} from "contexts/PermissionModalContext";

import './assets/scss/theme.scss'
import './assets/scss/user.scss'

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

const client = new QueryClient();

root.render(
    <React.StrictMode>
        <QueryClientProvider client={client}>
            <AppProvider>
                <SettingsPanelProvider>
                    <BreakpointsProvider>
                        <ToastProvider>
                            <PermissionModalProvider>
                                <RouterProvider router={router}/>
                            </PermissionModalProvider>
                        </ToastProvider>
                    </BreakpointsProvider>
                </SettingsPanelProvider>
            </AppProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
